// Surat Jalan Umum (general delivery note) — API helpers.
// Dokumen murni (tidak mengubah stok); backend di api-atalla-cms.

export function apiBase() {
  return (process.env.REACT_APP_INVENTORY_API_URL || "").replace(/\/$/, "")
}

async function apiFetch(path, { method = "GET", body } = {}) {
  const access_token = localStorage.getItem("access_token") ?? ""
  const res = await fetch(`${apiBase()}${path}`, {
    method,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access_token}`,
    },
    body: body ? JSON.stringify(body) : null,
  })

  const json = await res.json().catch(() => ({}))
  if (!res.ok) {
    const err = new Error(json?.message || "Request gagal")
    err.status = res.status
    err.validation = json?.errors || null
    throw err
  }
  return json
}

export function insertSuratJalanUmum(payload, createdBy) {
  return apiFetch("/surat-jalan-umum", {
    method: "POST",
    body: { ...payload, createdBy },
  })
}

export function updateSuratJalanUmum(id, payload, updatedBy) {
  return apiFetch(`/surat-jalan-umum/${id}`, {
    method: "PUT",
    body: { ...payload, updatedBy },
  })
}

export function showSuratJalanUmum(id) {
  return apiFetch(`/surat-jalan-umum/${id}`)
}

export function deleteSuratJalanUmum(id, deletedBy) {
  return apiFetch(`/surat-jalan-umum/${id}`, {
    method: "DELETE",
    body: { deletedBy },
  })
}

export function printSuratJalanUmumUrl(id) {
  return `${apiBase()}/surat-jalan-umum/${id}/print`
}

// 200726: faktur versi SJU (dokumen ber-harga; item price diisi di form edit).
export function printSuratJalanUmumFakturUrl(id) {
  return `${apiBase()}/surat-jalan-umum/${id}/print-faktur`
}
